







































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Fleche from '@/components/MainSection/Fleche.vue';
import GrandePeriode from '@/components/MainSection/GrandePeriode.vue';
import { eventBus } from '@/constants/bus';

const Velocity: any = require('velocity-animate');

@Component({
	components: {
		Fleche,
		GrandePeriode
	}
})
export default class MainSection extends Vue {
	$refs!: {
		grandesPeriodes: Array<HTMLElement>;
		grandesPeriodesWrapper: HTMLElement;
	};

	get ActiveGrandePeriode(): any {
		return this.$store.getters['getActiveGrandePeriodeIndex'];
	}

	get GrandesPeriodes(): any {
		return this.$store.getters['getGrandesPeriodes'];
	}

	get isMobile(): boolean {
		return this.$store.getters.getIsMobile;
	}

	public beforeEnter(el: any): void {
		el.style.opacity = 0;
		el.style.height = 0;
	}

	public enter(el: any, done: any): void {
		//var delay = el.dataset.index * 150;
		setTimeout(function() {
			Velocity(el, { opacity: 1, height: '100%' }, { complete: done });
		}, 0);
	}

	public leave(el: any, done: any): void {
		//var delay = el.dataset.index * 150;
		setTimeout(function() {
			Velocity(el, { opacity: 0, height: 0 }, { complete: done });
		}, 0);
	}

	private periodeChange(): void {
		eventBus.$emit(
			this.$store.getters.getActiveGrandePeriodeIndex + 'periodeChange',
			this.$store.getters.getActivePeriodeIndex
		);
	}

	private nextPeriode(): void {
		this.$store.commit('setNextActivePeriode');
		this.periodeChange();
	}

	private previousPeriode(): void {
		this.$store.commit('setPreviousActivePeriode');
		this.periodeChange();
	}

	private handleKey(e: any) {
		if (!this.$store.getters.getIsMobile) {
			e = e || window.event;

			if (e.keyCode == '38') {
				// up arrow
				this.$store.commit('setPreviousActiveGrandePeriode');
			} else if (e.keyCode == '40') {
				// down arrow
				this.$store.commit('setNextActiveGrandePeriode');
			} else if (e.keyCode == '37') {
				// left arrow
				this.previousPeriode();
			} else if (e.keyCode == '39') {
				// right arrow
				this.nextPeriode();
			}
		}
	}

	public onGrandePeriodeScroll(event: Event): void {
		let i = 0;
		while (i < this.$refs.grandesPeriodes.length) {
			if (
				this.$refs.grandesPeriodes[i].offsetTop >
				this.$refs.grandesPeriodesWrapper.scrollTop + 130
			) {
				this.$store.commit('setActiveGrandePeriodeIndex', i - 1);
				break;
			}

			i++;
		}
	}

	protected created(): void {
		document.onkeydown = this.handleKey;
	}

	protected beforeDestroy(): void {
		document.removeEventListener("onkeydown", this.handleKey);
	}
}
